import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBranch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="branch"><circle cx="6.5" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="6.5" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="17.5" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 8.25V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M17.5 8.25V12H6.5V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBranch;
